export enum CommunicationType {
  EMAIL = 'Email',
  MOBILE = 'Mobile',
}

export enum PasswordType {
  PASSWORD = 'Password',
  CONFIRM_PASSWORD = 'ConfirmPassword',
}

export interface SignUpRequest {
  firstName: string | undefined,
  lastName: string | undefined,
  email: string | undefined,
  mobile: string | undefined,
  password: string | undefined,
  confirmPassword: string | undefined,
  dob: Date | undefined,
  id?: string | undefined,
  createdBy?: string | undefined,
  isSelfEnrolled?: boolean,
  activeCommunicationTypes?: Array<string>
}

export interface SignUpResponse {
  status: boolean,
  error?: string,
  message?: string
}

export interface GenerateOtpRequest {
  communicationType: string,
  receiver: string,
  verificationType: string,
  appName?: string
}

export interface GenerateOtpResponse {
  status: boolean,
  error?: string,
  message?: string
}

export interface VerifyOtpRequest {
  communicationType: string,
  receiver: string,
  verificationType: string,
  otp: string,
  appName?: string
}

export interface VerifyOtpResponse {
  status: boolean,
  error?: string,
  message?: string
}

export interface ReceiverDet {
  communicationType: CommunicationType,
  receiver: string
}